/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import React from 'react';
import { WordExperiment } from '../../experiments/TrialConversion/WordExperiment';

export const WordView = () => {
    return <WordExperiment />;
};

export default WordView;
